export const __SocialMedias = [
    { name: 'website', label: 'وبسایت', link: 'https://' },
    { name: 'telegram', label: 'تلگرام', link: 'https://t.me/' },
    { name: 'instagram', label: 'اینستاگرام', link: 'https://instagram.com/' },
    { name: 'whatsapp', label: 'واتساپ', link: 'https://wa.me/' },
    { name: 'eitaa', label: 'ایتا', link: 'https://eitaa.com/' },
    { name: 'bale', label: 'بله', link: 'https://ble.ir/' },
    { name: 'rubika', label: 'روبیکا', link: 'https://rubika.ir/' },
    { name: 'linkedin', label: 'لینکدین', link: 'https://www.linkedin.com/' },
    { name: 'twitter', label: 'تویتر(ایکس)', link: 'https://x.com/' },
    { name: 'youtube', label: 'یوتیوب', link: 'https://youtube.com/@' },
    { name: 'facebook', label: 'فیسبوک', link: 'https://facebook.com/' },
    { name: 'discord', label: 'دیسکورد', link: 'https://disboard.org/' },
    { name: 'reddit', label: 'ردیت', link: 'https://www.reddit.com/' },
];
